import React, { useState } from 'react';
import ImageSection from './ImageSection'; // Import the ImageSection component

const ChangeImageConfirm = ({ orgName, onExpand }) => {
    const [changeImageClicked, setChangeImageClicked] = useState(false); // Change Image button state

    const buttonStyle = {
        display: 'block',
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold',
    };

    const changeImageButtonStyle = {
        ...buttonStyle,
        backgroundColor: changeImageClicked ? 'white' : '#343a40', // Invert color on click
        color: changeImageClicked ? '#343a40' : 'white',
        border: `2px solid #343a40`, // Add a border
    };

    const confirmWindowStyle = {
        width: '100%',
        marginTop: '10px',
        padding: '15px',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        border: `2px solid #343a40`, // Change Image outline color
        textAlign: 'center',
    };

    const textStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '10px',
    };

    const handleChangeImageClick = () => {
        setChangeImageClicked(!changeImageClicked);
        onExpand(!changeImageClicked); // Trigger modal expansion
    };

    const imageWrapperStyle = {
        display: 'flex',
        justifyContent: 'center', // Center the image sections horizontally
        flexWrap: 'wrap',
        gap: '20px', // Add spacing between image sections
    };

    return (
        <>
            <button style={changeImageButtonStyle} onClick={handleChangeImageClick}>
                Change Images
            </button>
            {changeImageClicked && (
                <div style={confirmWindowStyle}>
                    <p style={textStyle}>Edit Images for {orgName}</p>
                    <div style={imageWrapperStyle}>
                        {/* Render 6 example image sections */}
                        {[...Array(3).keys()].map((i) => (
                            <ImageSection key={i} title={`Image Section ${i + 1}`} />
                        ))}
                    </div>
                    <div style={{ marginTop: '15px', textAlign: 'right' }}>
                        <button className="btn btn-success" style={{ marginRight: '10px' }}>Save</button>
                        <button className="btn btn-secondary" onClick={handleChangeImageClick}>Cancel</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ChangeImageConfirm;
